// 'CS' closes both sales and rentals, so a known unit type decides the word;
// without one, fall back to the code itself ('R' only ever closes a rental).
export function getClosedStatusLabel(
  propertyTypeCode: string | null | undefined,
  statusCode: string
): 'Rented' | 'Sold' {
  const hasKnownType = !!propertyTypeCode && propertyTypeCode !== 'unknown';
  const isRental = hasKnownType ? propertyTypeCode === 'R' : statusCode === 'R';
  return isRental ? 'Rented' : 'Sold';
}
